// src/api/blogImages.ts
import { API_BASE_URL } from "../config";
import { getAdminToken } from "../auth";

export async function uploadBlogImages(files: File[]): Promise<string[]> {
  if (!files.length) return [];

  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files[]", file);
  });

  const token = getAdminToken();

  const res = await fetch(`${API_BASE_URL}/admin/blog_images`, {
    method: "POST",
    body: formData,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Upload failed: ${res.status} ${text}`);
  }

  const json = await res.json();
  return json.images || [];
}
